import {useEffect, useState} from 'react'

/**
 * Custom hook for auto-refresh functionality
 * @param {Function} refreshFunction - Function to call for refresh
 * @param {number} intervalMinutes - Refresh interval in minutes (default: 15)
 * @returns {Object} - {nextRefreshTime, handleManualRefresh}
 */
const useAutoRefresh = (refreshFunction, intervalMinutes = 15) => {
	const [nextRefreshTime, setNextRefreshTime] = useState(
		new Date(Date.now() + intervalMinutes * 60 * 1000)
	)

	useEffect(() => {
		// Set up auto-refresh interval
		const interval = setInterval(() => {
			refreshFunction()
			// Update next refresh time
			setNextRefreshTime(new Date(Date.now() + intervalMinutes * 60 * 1000))
		}, intervalMinutes * 60 * 1000) // Convert minutes to milliseconds

		// Cleanup interval on component unmount
		return () => clearInterval(interval)
	}, [refreshFunction, intervalMinutes])

	// Update next refresh time display every minute
	useEffect(() => {
		const updateInterval = setInterval(() => {
			setNextRefreshTime(new Date(Date.now() + intervalMinutes * 60 * 1000))
		}, 60 * 1000) // Update every minute

		return () => clearInterval(updateInterval)
	}, [intervalMinutes])

	const handleManualRefresh = () => {
		refreshFunction()
		// Reset next refresh time to interval from now
		setNextRefreshTime(new Date(Date.now() + intervalMinutes * 60 * 1000))
	}

	return {
		nextRefreshTime,
		handleManualRefresh,
	}
}

export default useAutoRefresh
